<template>
  <div class="button-accounts" :class="classModifier">
    <a href="#" :class="buttonClass" @click.prevent="openMenu">
      <svg :class="iconClass" width="21px" height="23px" v-if="iconId">
        <use :xlink:href="iconId"></use>
      </svg>
      <span>{{ label }}</span>
    </a>
    <PersonalAccountChoiceModal
      v-if="isMobile && this.isMenuOpen"
      :isMobileDevice="isMobile"
      @close="this.closeMenu"
    />
    <transition name="fade">
      <PersonalAccountChoicePopup
        v-show="!isMobile && this.isMenuOpen"
        :is-open="this.isMenuOpen"
        :is-enabled="!isMobile"
        @close="this.closeMenu"
      />
    </transition>
  </div>
</template>
<script>
/* global ym */
import Vue from 'vue';
import _ from 'lodash';
import PersonalAccountChoiceModal from './PersonalAccountChoiceModal.vue';
import PersonalAccountChoicePopup from './PersonalAccountChoicePopup.vue';

import deviceInfo from '../../helpers/device';
import { getters as lkPopupStateGetters, mutations as lkPopupStateMutations } from '../../models/lk-popup-state';

const component = {
  name: 'personalAccountButton',
  components: {
    PersonalAccountChoiceModal,
    PersonalAccountChoicePopup,
  },
  props: {
    buttonClass: {
      type: String,
      default: 'header__profile',
    },
    label: {
      type: String,
      default: 'Личный кабинет',
    },
    iconId: {
      type: String,
      default: '',
    },
    iconClass: {
      type: String,
      default: '',
    },
    classModifier: {
      type: String,
      default: '',
    },
    restorePopupMode: {
      type: String, // 'mobile', 'desktop', 'none'
      default: 'none',
    },
  },
  created() {
    this.doRestorePopupMode(this.isMobile);
  },
  data() {
    return {
      isMenuOpen: false,
    };
  },
  computed: {
    ...deviceInfo, // isMobile
  },
  methods: {
    ...lkPopupStateMutations,
    openMenu() {
      this.isMenuOpen = true;
      this.setWasOpen(true);

      if (typeof ym !== 'undefined') {
        ym(57872296, 'reachGoal', 'all_LK');
      }
    },
    closeMenu() {
      this.isMenuOpen = false;
      this.setWasOpen(false);
    },
    doRestorePopupMode(v) {
      let handled = false;

      if (v && this.restorePopupMode === 'mobile') {
        this.isMenuOpen = lkPopupStateGetters.wasOpen();
        handled = true;
      }

      if (!v && this.restorePopupMode === 'desktop') {
        this.isMenuOpen = lkPopupStateGetters.wasOpen();
        handled = true;
      }

      if (!handled) {
        this.isMenuOpen = false;
      }
    },
  },
  watch: {
    isMobile(v) {
      this.doRestorePopupMode(v);
    },
  },
};

const factory = function (options) {
  const props = _.extend({
    el: '.header__profile',
  }, options);

  const { el } = props;

  delete props.el;

  const instance = new Vue({
    ...component,
    propsData: props,
  });

  if (el) {
    instance.$mount(el);
  }

  return instance;
};

export { factory, component as default };

</script>
<style lang="scss">
@import './PersonalAccountChoiceModal.scss';
</style>
